import { documentation, isComponent } from '../utils/Documentation';
import { hasName } from '@inmoment/the-kitchen/props/the-kitchen';
import { TextAccordionCategory, TextAccordionPage } from '../cookbook-ui/custom-components/TextAccordion/TextAccordion.model';

export const ComponentNavPages = documentation.allCategories.reduce<TextAccordionCategory>(
  (categoriesNav, category) => {
    const exports = documentation.byAllCategory[category]?.filter(hasName);
    if (!exports || exports.length === 0) {
      return categoriesNav;
    }

    const categoryNav = exports.reduce<TextAccordionPage>(
      (categoryNav, e) => {
        if (isComponent(e)) {
          const id = e.name;
          categoryNav.containsIds!.push(id);
          categoryNav.sections!.push({
            title: e.name,
            id,
            href: `${categoryNav.href}#${id}`,
          });
        }
        return categoryNav;
      },
      {
        title: category,
        href: `/${category}`,
        containsIds: [],
        sections: [],
      },
    );

    categoriesNav.containsIds.push(...categoryNav.containsIds!);
    (categoriesNav.items as TextAccordionPage[]).push(categoryNav);
    return categoriesNav;
  },
  {
    title: 'Components',
    id: '3000',
    containsIds: [],
    items: [],
  },
);
